import "./atoms-v2886.js";
import { resolveElements as m } from "./atoms-v2972.js";
const p = {
  some: 0,
  all: 1
};
function b(c, f, { root: a, margin: l, amount: t = "some" } = {}) {
  const g = m(c), n = /* @__PURE__ */ new WeakMap(), h = (s) => {
    s.forEach((e) => {
      const r = n.get(e.target);
      if (e.isIntersecting !== !!r)
        if (e.isIntersecting) {
          const i = f(e);
          typeof i == "function" ? n.set(e.target, i) : o.unobserve(e.target);
        } else
          typeof r == "function" && (r(e), n.delete(e.target));
    });
  }, o = new IntersectionObserver(h, {
    root: a,
    rootMargin: l,
    threshold: typeof t == "number" ? t : p[t]
  });
  return g.forEach((s) => o.observe(s)), () => o.disconnect();
}
export {
  b as inView
};
